import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Workspace } from '../models/workspace';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceService extends CrudService<Workspace> {
  protected basePath = 'workspace';
  public instanceType = 'workspace';

  constructor(http: HttpClient) {
    super(http);
  }
}
